import React, { Suspense, lazy } from 'react';
import MainLoader from '~components/main-loader';

const StatisticsPage = lazy(() => import('./index.js'))

function StatisticsPageLazy(props) {
    return (
        <Suspense fallback={<MainLoader />}>
            <StatisticsPage {...props} />
        </Suspense>
    );
}

export default StatisticsPageLazy;
export { StatisticsPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/statistics-item-page/lazy.js